import config from "../config";

class ApiClient {
    constructor(token) {
        this.baseUrl = config.backend.url;
        this.token = token;
    }

    // Helper pour exécuter une requête HTTP
    async request(endpoint, method = 'GET', body = null) {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`,
        };

        const options = {
            method,
            headers,
        };

        if (body) {
            options.body = JSON.stringify(body);
        }

        const response = await fetch(`${this.baseUrl}${endpoint}`, options);
        if (!response.ok) {
            const errorMessage = await response.text();
            throw new Error(
                `Erreur ${response.status} : ${response.statusText} - ${errorMessage}`
            );
        }

        try {
            const json = await response.json();

            // Extraire les données utiles (par exemple, sous `data` si présent)
            if (json?.data !== undefined) {
                return json.data; // Retourne uniquement les données pertinentes
            }

            return json; // Sinon, retourne tout l'objet JSON
        } catch (error) {
            console.error("Erreur JSON :", error);
            throw new Error("Réponse non valide de l'API");
        }

    }

    // **GROUPES**

    // Récupère la liste des groupes
    async getGroups() {
        return this.request('/taleez/groups');
    }

    // Récupère les membres d’un groupe
    async getGroupMembers(groupId) {
        return this.request(`/groups/${groupId}/members`);
    }

    // **MISSIONS**

    // Récupère la liste des missions
    async getMissions() {
        return this.request('/taleez/missions');
    }

    async getMissionById(id) {
        return this.request('/taleez/missions/' + id);
    }

    // Affecte une mission à un ou plusieurs membres
    async sendCampaign(campaignData) {
        return this.request(`/taleez/sendCampaign`, 'POST', campaignData);
    }

    // récupère les statistiques
    async getStats(args) {
        return this.request(`/whatsapp/stats` + args, 'GET');
    }

    async getProperties(){
        return this.request(`/taleez/properties`, 'GET');
    }

    async getCandidatesByFilters(filters) {
        return this.request(`/taleez/candidates`, 'POST', filters);
    }
}

// Singleton : On instancie une seule fois l'ApiClient avec un point d'API par défaut
// const apiClientInstance = new ApiClient();
//
export default ApiClient;

